import {
  USER_ACTIVATE_FAIL,
  USER_ACTIVATE_REQUEST,
  USER_ACTIVATE_RESET,
  USER_ACTIVATE_SUCCESS,
  USER_ADMIN_COMPLETE_SIGNUP_FAIL,
  USER_ADMIN_COMPLETE_SIGNUP_REQUEST,
  USER_ADMIN_COMPLETE_SIGNUP_RESET,
  USER_ADMIN_COMPLETE_SIGNUP_SUCCESS,
  USER_ADMIN_LIST_FAIL,
  USER_ADMIN_LIST_REQUEST,
  USER_ADMIN_LIST_RESET,
  USER_ADMIN_LIST_SUCCESS,
  USER_ADMIN_UPDATE_INFO_FAIL,
  USER_ADMIN_UPDATE_INFO_REQUEST,
  USER_ADMIN_UPDATE_INFO_RESET,
  USER_ADMIN_UPDATE_INFO_SUCCESS,
  USER_CONFIRM_VALIDATION_FAIL,
  USER_CONFIRM_VALIDATION_REQUEST,
  USER_CONFIRM_VALIDATION_RESET,
  USER_CONFIRM_VALIDATION_SUCCESS,
  USER_DEACTIVATE_FAIL,
  USER_DEACTIVATE_REQUEST,
  USER_DEACTIVATE_RESET,
  USER_DEACTIVATE_SUCCESS,
  USER_DELETE_FAIL,
  USER_DELETE_REQUEST,
  USER_DELETE_RESET,
  USER_DELETE_SUCCESS,
  USER_DETAILS_FAIL,
  USER_DETAILS_REQUEST,
  USER_DETAILS_RESET,
  USER_DETAILS_SUCCESS,
  USER_INVITE_FAIL,
  USER_INVITE_REQUEST,
  USER_INVITE_RESET,
  USER_INVITE_SUCCESS,
  USER_LIST_FAIL,
  USER_LIST_REQUEST,
  USER_LIST_RESET,
  USER_LIST_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGOUT,
  USER_LOGOUT_RESET,
  USER_REGISTER_FAIL,
  USER_REGISTER_REQUEST,
  USER_REGISTER_RESET,
  USER_REGISTER_SUCCESS,
  USER_RESET_PASSWORD_FAIL,
  USER_RESET_PASSWORD_LINK_FAIL,
  USER_RESET_PASSWORD_LINK_REQUEST,
  USER_RESET_PASSWORD_LINK_RESET,
  USER_RESET_PASSWORD_LINK_SUCCESS,
  USER_RESET_PASSWORD_REQUEST,
  USER_RESET_PASSWORD_RESET,
  USER_RESET_PASSWORD_SUCCESS,
  USER_UPDATE_INFO_FAIL,
  USER_UPDATE_INFO_REQUEST,
  USER_UPDATE_INFO_RESET,
  USER_UPDATE_INFO_SUCCESS,
  USER_UPDATE_PASSWORD_FAIL,
  USER_UPDATE_PASSWORD_REQUEST,
  USER_UPDATE_PASSWORD_RESET,
  USER_UPDATE_PASSWORD_SUCCESS,
} from '../constants/userConstants'
import { ActionWithPayload } from '../store'

const user =
  localStorage.getItem('userInfo') || sessionStorage.getItem('userInfo')
const userInfoFromStorage = user ? JSON.parse(user) : null

const initialState: UserLogin = {
  userInfo: userInfoFromStorage,
  error: undefined,
  loading: false,
  success: false,
  userLoggedOut: false,
}

export const userLoginReducer = (
  state = initialState,
  action: ActionWithPayload<UserLogin>
) => {
  switch (action.type) {
    case USER_LOGIN_REQUEST:
      return { loading: true }
    case USER_LOGIN_SUCCESS:
      return { loading: false, userInfo: action.payload }
    case USER_LOGIN_FAIL:
      return { loading: false, error: action.payload }
    case USER_LOGOUT:
      return { userLoggedOut: true }
    case USER_LOGOUT_RESET:
      return { userLoggedOut: false }
    default:
      return state
  }
}

export const userRegisterReducer = (
  state = {},
  action: ActionWithPayload<any>
) => {
  switch (action.type) {
    case USER_REGISTER_REQUEST:
      return { loading: true }
    case USER_REGISTER_SUCCESS:
      return { loading: false, success: true, registration: action.payload }
    case USER_REGISTER_FAIL:
      return { loading: false, error: action.payload }
    case USER_REGISTER_RESET:
      return {}
    default:
      return state
  }
}

export const userDetailsReducer = (
  state = { user: {} },
  action: ActionWithPayload<any>
) => {
  switch (action.type) {
    case USER_DETAILS_REQUEST:
      return { ...state, loading: true }
    case USER_DETAILS_SUCCESS:
      return { loading: false, user: action.payload }
    case USER_DETAILS_FAIL:
      return { loading: false, error: action.payload }
    case USER_DETAILS_RESET:
      return { user: {} }
    default:
      return state
  }
}

export const userUpdateInfoReducer = (
  state = {},
  action: ActionWithPayload<any>
) => {
  switch (action.type) {
    case USER_UPDATE_INFO_REQUEST:
      return { loading: true }
    case USER_UPDATE_INFO_SUCCESS:
      return { loading: false, success: true, userInfo: action.payload }
    case USER_UPDATE_INFO_FAIL:
      return { loading: false, error: action.payload }
    case USER_UPDATE_INFO_RESET:
      return {}
    default:
      return state
  }
}

export const userUpdateAdminInfoReducer = (
  state = {},
  action: ActionWithPayload<any>
) => {
  switch (action.type) {
    case USER_ADMIN_UPDATE_INFO_REQUEST:
      return { loading: true }
    case USER_ADMIN_UPDATE_INFO_SUCCESS:
      return { loading: false, success: true, userInfo: action.payload }
    case USER_ADMIN_UPDATE_INFO_FAIL:
      return { loading: false, error: action.payload }
    case USER_ADMIN_UPDATE_INFO_RESET:
      return {}
    default:
      return state
  }
}

export const userAdminCompleteSignUpReducer = (
  state = {},
  action: ActionWithPayload<any>
) => {
  switch (action.type) {
    case USER_ADMIN_COMPLETE_SIGNUP_REQUEST:
      return { loading: true }
    case USER_ADMIN_COMPLETE_SIGNUP_SUCCESS:
      return { loading: false, success: true }
    case USER_ADMIN_COMPLETE_SIGNUP_FAIL:
      return { loading: false, error: action.payload }
    case USER_ADMIN_COMPLETE_SIGNUP_RESET:
      return {}
    default:
      return state
  }
}

export const userDeleteReducer = (
  state = { user: {} },
  action: ActionWithPayload<any>
) => {
  switch (action.type) {
    case USER_DELETE_REQUEST:
      return { ...state, loading: true }
    case USER_DELETE_SUCCESS:
      return { loading: false, success: true }
    case USER_DELETE_FAIL:
      return { loading: false, error: action.payload }
    case USER_DELETE_RESET:
      return { user: {} }
    default:
      return state
  }
}

export const userListReducer = (
  state = { users: [] },
  action: ActionWithPayload<any>
) => {
  switch (action.type) {
    case USER_LIST_REQUEST:
      return { loading: true }
    case USER_LIST_SUCCESS:
      return { loading: false, users: action.payload }
    case USER_LIST_FAIL:
      return { loading: false, error: action.payload }
    case USER_LIST_RESET:
      return { users: [] }
    default:
      return state
  }
}

export const userAdminListReducer = (
  state = { users: [] },
  action: ActionWithPayload<any>
) => {
  switch (action.type) {
    case USER_ADMIN_LIST_REQUEST:
      return { loading: true }
    case USER_ADMIN_LIST_SUCCESS:
      return { loading: false, users: action.payload }
    case USER_ADMIN_LIST_FAIL:
      return { loading: false, error: action.payload }
    case USER_ADMIN_LIST_RESET:
      return { users: [] }
    default:
      return state
  }
}

export const userDeactivateReducer = (
  state = {},
  action: ActionWithPayload<any>
) => {
  switch (action.type) {
    case USER_DEACTIVATE_REQUEST:
      return { loading: true }
    case USER_DEACTIVATE_SUCCESS:
      return { loading: false, success: true }
    case USER_DEACTIVATE_FAIL:
      return { loading: false, error: action.payload }
    case USER_DEACTIVATE_RESET:
      return {}
    default:
      return state
  }
}

export const userActivateReducer = (
  state = {},
  action: ActionWithPayload<any>
) => {
  switch (action.type) {
    case USER_ACTIVATE_REQUEST:
      return { loading: true }
    case USER_ACTIVATE_SUCCESS:
      return { loading: false, success: true }
    case USER_ACTIVATE_FAIL:
      return { loading: false, error: action.payload }
    case USER_ACTIVATE_RESET:
      return {}
    default:
      return state
  }
}

export const userConfirmEmailReducer = (
  state = {},
  action: ActionWithPayload<any>
) => {
  switch (action.type) {
    case USER_CONFIRM_VALIDATION_REQUEST:
      return { loading: true }
    case USER_CONFIRM_VALIDATION_SUCCESS:
      return { loading: false, success: true }
    case USER_CONFIRM_VALIDATION_FAIL:
      return { loading: false, error: action.payload }
    case USER_CONFIRM_VALIDATION_RESET:
      return {}
    default:
      return state
  }
}

export const userResetPasswordReducer = (
  state = {},
  action: ActionWithPayload<any>
) => {
  switch (action.type) {
    case USER_RESET_PASSWORD_REQUEST:
      return { loading: true }
    case USER_RESET_PASSWORD_SUCCESS:
      return { loading: false, success: true }
    case USER_RESET_PASSWORD_FAIL:
      return { loading: false, error: action.payload }
    case USER_RESET_PASSWORD_RESET:
      return {}
    default:
      return state
  }
}

export const userGeneratePasswordResetLinkReducer = (
  state = {},
  action: ActionWithPayload<any>
) => {
  switch (action.type) {
    case USER_RESET_PASSWORD_LINK_REQUEST:
      return { ...state, loading: true }
    case USER_RESET_PASSWORD_LINK_SUCCESS:
      return { ...state, loading: false, confirmationCode: action.payload }
    case USER_RESET_PASSWORD_LINK_FAIL:
      return { ...state, loading: false, error: action.payload }
    case USER_RESET_PASSWORD_LINK_RESET:
      return {}
    default:
      return state
  }
}

export const userUpdatePasswordReducer = (
  state = {},
  action: ActionWithPayload<any>
) => {
  switch (action.type) {
    case USER_UPDATE_PASSWORD_REQUEST:
      return { loading: true }
    case USER_UPDATE_PASSWORD_SUCCESS:
      return { loading: false, success: true }
    case USER_UPDATE_PASSWORD_FAIL:
      return { loading: false, error: action.payload }
    case USER_UPDATE_PASSWORD_RESET:
      return {}
    default:
      return state
  }
}

export const userInviteReducer = (
  state = { invitedUser: {} },
  action: ActionWithPayload<any>
) => {
  switch (action.type) {
    case USER_INVITE_REQUEST:
      return { loading: true }
    case USER_INVITE_SUCCESS:
      return { loading: false, success: true, invitedUser: action.payload }
    case USER_INVITE_FAIL:
      return { loading: false, error: action.payload }
    case USER_INVITE_RESET:
      return {}
    default:
      return state
  }
}
